export const directConnect = async _ref => {
  let {
    paymentProviderId,
    paymentMethodTypesIds,
    credentials,
    paymentMethodTitle,
    context
  } = _ref;
  const {
    httpClient,
    send
  } = context;
  const requestParams = {
    paymentProviderId,
    paymentMethodTypesIds,
    credentials
  };
  await httpClient.post('/_serverless/payments-assistant/saveCredentials', requestParams);
  void send(`I clicked on "Connect ${paymentMethodTitle}".`);
};
//# sourceMappingURL=directConnect.js.map